import Form from "../../components/forms/form";
import {AnalyticsService} from "../../services/analytics-service";

export default class LeadMagnet {
    constructor() {
        this.$root = document.getElementById('leadMagnet');

        this.cookie = costorage.get('h_leadMagnet');
        this.miniMagnetCookie = costorage.get('h_miniMagnet');
        this.showDelay = 30000;

        this.init();
    }

    init() {
        if (this.$root == null || this.cookie || !this.miniMagnetCookie || !window.matchMedia('(min-width: 769px)').matches) {
            return;
        }

        this.$close = this.$root.querySelector('.lead-magnet_close');
        this.$cancelButton = this.$root.querySelector('.btn-decline');

        this.$close.addEventListener('click', this.hide.bind(this));
        this.$cancelButton.addEventListener('click', this.hide.bind(this));

        setTimeout(() => {
            this.initForm();
            this.show();
        }, this.showDelay);
    }

    initForm() {
        try {
            const form = new Form({
                formId: 'lead-magnet',
                uri: '/1.0/courses/lead-magnet',
                data: {
                    branding: 'bookford'
                },
                submitConf: {
                    animation: false
                },
                subscriptions: [{
                    event: 'beforeSubmit',
                    callback: () => {
                        /* GTM Event */
                        const dataLayerEventData = {
                            event: 'leadmagnet_popup_form',
                            formId: form.formId,
                            phone: form.data.tel,
                            email: form.data.email
                        };

                        AnalyticsService.sendEvent('leadmagnet_popup_form', dataLayerEventData);

                        this.hide();
                    }
                }]
            });
        } catch (err) {
            console.error('Lead Magnet Form:', err);
        }
    }

    setCookie() {
        costorage.set('h_leadMagnet', 1, {
            expires: 45 * 24 * 60 * 60,
            domain: '.bookford.com',
            path: "/"
        });
    }

    show() {
        this.$root.style.display = null;
        setTimeout(() => {
            this.$root.classList.add('-show');
        }, 20);
    }

    hide() {
        this.$root.classList.remove('-show');
        this.setCookie();
    }
}